import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function useCasesCount(myCases = true) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [casesCount, setCasesCount] = useState({
    totalCases: 0,
    todayCases: 0,
  });
  const navigate = useNavigate();

  const fetch = () => {
    setLoading(true);
    setError(false);
    let cancel;
    axios({
      method: "GET",
      url: "/api/staffMembers/casesCount",
      params: { myCases },
      cancelToken: new axios.CancelToken((c) => (cancel = c)),
    })
      .then((res) => {
        setCasesCount(res.data);
        setLoading(false);
      })
      .catch((e) => {
        if (axios.isCancel(e)) return;
        if (process.env.NODE_ENV === 'development') {
          // API not available in development
        }
        setError(true);
        setLoading(false);
      });
    return () => cancel();
  };

  useEffect(() => {
    fetch();
  }, [myCases]);

  return { loading, error, casesCount, fetch };
}
